import React from 'react'
import { PhoneInputProps } from 'src/shared/components/phone-input'
import {
  PhoneNumberFieldUi,
  PhoneNumberFieldUiStylesInterface,
} from './ui/phone-number-field-ui'

export interface PhoneNumberFieldNewProps
  extends PhoneNumberFieldUiStylesInterface,
    PhoneInputProps {
  isLoading?: boolean
}

export const PhoneNumberFieldNew = ({
  isLoading,
  disabled,
  hideDropdown,
  countrySelectorProps,
  ...props
}: PhoneNumberFieldNewProps) => {
  const isInputDisabled = isLoading || disabled
  const isDropdownHidden = isLoading || hideDropdown

  return (
    <PhoneNumberFieldUi
      {...props}
      disabled={isInputDisabled}
      hideDropdown={isDropdownHidden}
      countrySelectorProps={{
        ...countrySelectorProps,
        disabled: isLoading || countrySelectorProps?.disabled,
        hideDropdown: countrySelectorProps?.hideDropdown ?? hideDropdown,
        isCountryLoading: isLoading || countrySelectorProps?.isCountryLoading,
      }}
    />
  )
}
